import { GetStaticProps } from 'next';

export const NextUtils = {
  isServer() {
    return typeof window === 'undefined';
  },
  getNullableProps<T extends { [key: string]: any }>(
    props: ReturnType<GetStaticProps<T>>,
  ) {
    return JSON.parse(JSON.stringify(props));
  },
};
